import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shadow", "radius", "padding", "autoHeight", "onClick", "children"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/Card.js",
    _this = this;

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { noop, testIdProps } from '../../helpers';
import { useTheme } from '../../core/ThemeProvider';
import { shadowTypes, radiusTypes, paddingTypes, getShadow, getRadius, getPadding } from './mapValues';
import { CardContainer } from './style';
import CardContent from './CardContent';
import CardImage from './CardImage';
import CardTitle from './CardTitle';
import CardInfo from './CardInfo';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import CardIconList from './CardIconList';

var CardComponent = function CardComponent(props, ref) {
  var shadow = props.shadow,
      radius = props.radius,
      padding = props.padding,
      autoHeight = props.autoHeight,
      onClick = props.onClick,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  return /*#__PURE__*/React.createElement(CardContainer, _extends({}, testIdProps(rest), {
    ref: ref,
    onClick: onClick,
    shadow: getShadow(shadow, theme),
    radius: getRadius(radius, theme),
    padding: getPadding(padding, theme),
    autoHeight: autoHeight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }), children);
};

var Card = /*#__PURE__*/forwardRef(CardComponent);
Card.defaultProps = {
  onClick: noop,
  shadow: shadowTypes.sm,
  radius: radiusTypes.sm,
  padding: paddingTypes.sm,
  autoHeight: false
};
Card.propTypes = {
  shadow: PropTypes.oneOf([shadowTypes.sm, shadowTypes.lg]),
  radius: PropTypes.oneOf([radiusTypes.sm, radiusTypes.md, radiusTypes.lg]),
  padding: PropTypes.oneOf([paddingTypes.sm, paddingTypes.md, paddingTypes.lg]),
  autoHeight: PropTypes.bool,
  onClick: PropTypes.func
};
Card.Content = CardContent;
Card.Image = CardImage;
Card.Title = CardTitle;
Card.Info = CardInfo;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.IconList = CardIconList;
export default Card;